




import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from '../Layout';
import Login from '../Components/AuthComponent/SignInProcess/login';
import UserManagement from '../Components/AdminComponents/User Management/dashboard';
import Subscription from '../Components/AdminComponents/Subscription/subsciption';
import Meditation from '../Components/AdminComponents/Meditation/meditation';
import Support from '../Components/AdminComponents/Support/support';
import PrivateRoute from '../Utils/privateRoute';
import MeditationDetail from '../Components/AdminComponents/User Management/medidation-detail/meditationDetail';
import SubscriptionDetail from '../Components/AdminComponents/Subscription/subscriptiondetails/subscriptionDetail';
import AudioPlayer from '../Components/SharedComponents/AudioPlayer';
import Venue from '../Components/AdminComponents/Venue/dashboard';
import VenueDetail from '../Components/AdminComponents/Venue/VenueDetail';
import Offer from '../Components/offer/dashboard';
import OfferDetail from '../Components/offer/offerDetail';
import UserDetail from '../Components/AdminComponents/User Management/userDetail';
import Event from '../Components/Event/dashboard';
import EventDetail from '../Components/Event/eventDetail';

export default function Routing() {
  return (
    <AudioPlayer>
      {({ playAudioMain, currentlyPlayingId }) => (
        <>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Login />} />

            {/* Protected Routes */}
            <Route path="/admin" element={<PrivateRoute />}>
              <Route element={<Layout />}>
                <Route path="user-management" element={<UserManagement />} />
                <Route path="user-management/detail/:id" element={<UserDetail />} />
                <Route path="venue" element={<Venue />} />
                <Route path="venue/detail/:id" element={<VenueDetail />} />
                <Route path="offer" element={<Offer />} />
                <Route path="offer/detail/:id" element={<OfferDetail />} />
                <Route path="event" element={<Event />} />
                <Route path="event/detail/:id" element={<EventDetail />} />
                {/* <Route path="user-management/medidation-detail" element={<MeditationDetail playAudio={playAudioMain} currentlyPlayingId={currentlyPlayingId} />} />
                <Route path="subscription" element={<Subscription />} />
                <Route path="subscription/detail" element={<SubscriptionDetail />} />
                <Route path="meditaion" element={<Meditation playAudio={playAudioMain} currentlyPlayingId={currentlyPlayingId} />} />
                <Route path="support" element={<Support />} /> */}
              </Route>
            </Route>
          </Routes>
          <ToastContainer />
        </>
      )}
    </AudioPlayer>
  );
}